import {useMemo} from 'react'
import {useLocation} from 'react-router-dom'

import {hasAccess, hasMatch} from '../route-utils'
import {Profile} from "../types/allTypes";

export const useAuthRedirect = (profile?: Profile, noRedirect = false) => {
  const {pathname, search, hash} = useLocation()
  const searchParams = useMemo(() => new URLSearchParams(search), [search])

  const returnUrl = encodeURIComponent(`${pathname}${search}${hash}`)

  if (profile == null) {
    if (noRedirect && pathname === '/sign-in') return
    if (noRedirect || (pathname === '/sign-in' && search === ''))
      return '/sign-in?from=/'
    if (pathname === '/sign-in') return

    return `/sign-in?from=${returnUrl}`
  }

  const redirectUrl = searchParams.get('from')

  if (redirectUrl) return redirectUrl

  const notFound = !hasMatch(profile.roles, pathname)

  if (notFound) return '/not-found'

  const forbidden = !hasAccess(profile.roles, pathname)

  if (forbidden) return '/forbidden'

  if (pathname === '/forbidden') return '/'
}
